import React from 'react';

import moment from 'moment';

import {
  GlobalStyle,
  Header,
  Text,
  Content,
  Date,
  Arrow,
} from './styles';

export const datePickHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => {
  moment.locale('pt-BR');

  return (
    <Header>
      <GlobalStyle />
      <Text>DATA MARCADA</Text>
      <Content>
        <Arrow onClick={decreaseMonth}>{'<'}</Arrow>
        <Date>{moment(date).format('MMMM / YYYY')}</Date>
        <Arrow onClick={increaseMonth}>{'>'}</Arrow>
      </Content>
    </Header>
  );
};
